import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();

export type CategoryItemType = {
  id: string;
  name: string;
  uri: string;
  parentId: string;
  children?: CategoryItemType[];
};

export const getCategories = async (
  locale: string,
  httpClient: HttpClientFactory,
): Promise<CategoryItemType[]> => {
  try {
    const response = await httpClient
      .getInstance()
      .get(`${clientTopology.getCategoriesURL}?locale=${locale}`);
    return response.data;
  } catch (error) {
    logger.log({
      message: 'failed to fetch get all categories',
      error,
    });
    console.error(error);
    throw error;
  }
};
